import {
	DeploymentBranding as PhoenixDeploymentBranding,
	ImageMimeType,
} from 'phoenix/domain';
import { Serializable } from 'util/domain';

const primaryShareBaseBlueWeb = '#00586E';
const nullPhoenixDeploymentBranding:PhoenixDeploymentBranding = {
	EmailHeaderColor: null,
	ExternalShareLogoInBase64: null,
	ExternalShareLogoMimeType: null,
	IsActive: false,
	IsDefault: false,
	Links: { Self: null },
	LogoInBase64: null,
	LogoMimeType: null,
	SystemName: null
}

export class DeploymentBranding extends Serializable<PhoenixDeploymentBranding> {
	public emailLogoInBase64: string;
    public emailLogoMimeType: ImageMimeType;
	public webLogoInBase64: string;
	public webLogoMimeType: ImageMimeType;
	public headerColor: string;
    public isActive: boolean;
	public isDefault: boolean;
	
	//ShareBase's default utilizes a different logo and header color than the email branding, so this was created specifically
	//for that purpose
	public get webHeaderColor() {
		if(this.isDefault && !this.isHeaderColorDirty) {
			return primaryShareBaseBlueWeb;
		}
		else {
			return this.headerColor;
		}
	}

	constructor(
		source:PhoenixDeploymentBranding = angular.copy(nullPhoenixDeploymentBranding)
	) {
		super(source);

		this.resetToSource();
	}
	
	public toApi(): PhoenixDeploymentBranding {
		return {
			EmailHeaderColor: this.headerColor,
			ExternalShareLogoInBase64: this.webLogoInBase64,
			ExternalShareLogoMimeType: this.webLogoMimeType,
			IsActive: this.isActive,
			IsDefault: this.isDefault,
			Links: this.source.Links,
			LogoInBase64: this.emailLogoInBase64,
			LogoMimeType: this.emailLogoMimeType,
			SystemName: this.source.SystemName
		}
	}

	public get isDirty() {
		return this.isEmailLogoDirty || this.isHeaderColorDirty || this.isWebLogoDirty;
	}

	public get isEmailLogoDirty() {
		return this.emailLogoInBase64 !== this.source.LogoInBase64;
	}

	public get isHeaderColorDirty() {
		return this.headerColor !== this.source.EmailHeaderColor;
	}

	public get isWebLogoDirty() {
		return this.webLogoInBase64 !== this.source.ExternalShareLogoInBase64;
	}

	public resetEmailLogo() {
		if(this.isEmailLogoDirty) {
			this.emailLogoInBase64 = this.source.LogoInBase64;
			this.emailLogoMimeType = this.source.LogoMimeType;
		}
	}

	public resetHeaderColor() {
		if(this.isHeaderColorDirty) {
			this.headerColor = this.source.EmailHeaderColor;
		}		
	}

	public resetToSource() {
		if(this.isDirty) {
			this.emailLogoInBase64 = this.source.LogoInBase64;
			this.emailLogoMimeType = this.source.LogoMimeType;
			this.webLogoInBase64 = this.source.ExternalShareLogoInBase64;
			this.webLogoMimeType = this.source.ExternalShareLogoMimeType;
			this.headerColor = this.source.EmailHeaderColor;
			this.isActive = this.source.IsActive;
			this.isDefault = this.source.IsDefault;

			//Since the columns are nullable and the web logo option was released after the email logo
			//check if there is a web logo, and if not, default it to the email one.
			//This should be able to be removed eventually, as the branding configuration page will require both.
			if(this.source.LogoInBase64 && !this.source.ExternalShareLogoInBase64) {
				this.webLogoInBase64 = this.emailLogoInBase64;
				this.webLogoMimeType = this.emailLogoMimeType;	
			}
		}
	}

	public resetWebLogo() {
		if(this.isWebLogoDirty) {
			this.webLogoInBase64 = this.source.ExternalShareLogoInBase64;
			this.webLogoMimeType = this.source.ExternalShareLogoMimeType;
		}		
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/deployment-branding.ts